import React, { useContext, useState } from 'react';

import {
  AS_INSTRUCTION,
  CATEGORY,
  CONFIDENCE,
  DEFAULT_MODIFIERS,
  MAPPING_STATUS_COLUMN,
  NAME_OBJECT_KEY,
  PARENT_NAMES,
  PRICE,
  SHOW_DEFAULT_MODIFIERS,
  UUID_EXTERNAL_ID,
  UUID_NAME,
  IGNORE,
} from 'constants/mapping';
import { CAMEL_TYPES } from 'constants/menuManagement';

import { findMappingStatus, formatConfidence } from 'helpers/mapping';

import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';
import MappingActionButtons from 'components/Mapping/Tabs/MappingActionButtons';
import PanelContent from 'components/Mapping/TableView/PanelContent';

export default function MainItemTable() {
  const [filteredName, setFilteredName] = useState('');
  const [filteredStatuses, setFilteredStatuses] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [sortFilters, setSortFilters] = useState({ order_by: '', sort_order: '' });

  const { appMenu, posMenu, formatPrice, renderMappingActionButtons } =
    useContext(MenuMappingContext);

  const formatDefaultModifiers = item => {
    if (!item.defaultModifiers) return [];
    return item.defaultModifiers.split(',');
  };

  const handleSort = orderBy => {
    if (orderBy === sortFilters.order_by) {
      setSortFilters({
        order_by: orderBy,
        sort_order: sortFilters.sort_order === 'asc' ? 'desc' : 'asc',
      });
    } else {
      setSortFilters({ order_by: orderBy, sort_order: 'asc' });
    }
  };

  const columns = [
    {
      key: 'status',
      title: 'Status',
    },
    {
      key: 'cn_name',
      title: 'CN Name',
      labelKey: 'uuidName',
      sorter: handleSort,
      filters: sortFilters,
    },
    {
      key: 'price',
      title: 'Price',
      labelKey: 'price',
      sorter: handleSort,
      filters: sortFilters,
    },
    {
      key: 'cn_category',
      title: 'CN Category',
      labelKey: 'parentNames',
      sorter: handleSort,
      filters: sortFilters,
    },
    {
      key: 'pos_item',
      title: 'POS item detail',
    },
    {
      key: 'match',
      title: 'Match',
      labelKey: 'confidence',
      sorter: handleSort,
      filters: sortFilters,
    },
    {
      key: 'flag',
      title: 'Flag',
    },
    {
      key: 'edit',
      title: 'Edit',
    },
  ];

  const formatData = (() => {
    if (!appMenu[CAMEL_TYPES.items]) return [];
    let mainItemList = Object.values(appMenu[CAMEL_TYPES.items]);
    if (filteredName) {
      mainItemList = mainItemList.filter(item =>
        item[UUID_NAME].toLowerCase().includes(filteredName.toLowerCase()),
      );
    }

    if (filteredStatuses.length) {
      mainItemList = mainItemList.filter(item =>
        filteredStatuses.includes(
          findMappingStatus({
            item,
            posMenu,
            itemType: CAMEL_TYPES.items,
          }),
        ),
      );
    }

    if (filteredCategories.length) {
      mainItemList = mainItemList.filter(item =>
        filteredCategories.includes(item[PARENT_NAMES][0]),
      );
    }

    if (sortFilters.order_by) {
      if (sortFilters.sort_order === 'asc') {
        mainItemList = mainItemList.sort((a, b) => {
          if (a[sortFilters.order_by] < b[sortFilters.order_by]) return -1;
          if (a[sortFilters.order_by] > b[sortFilters.order_by]) return 1;
          return 0;
        });
      } else {
        mainItemList = mainItemList.sort((a, b) => {
          if (a[sortFilters.order_by] > b[sortFilters.order_by]) return -1;
          if (a[sortFilters.order_by] < b[sortFilters.order_by]) return 1;
          return 0;
        });
      }
    }

    return mainItemList.map(item => ({
      key: item.uuidUuid,
      [NAME_OBJECT_KEY]: item.uuidName,
      [CATEGORY]: item[PARENT_NAMES],
      [PRICE]: formatPrice(item[PRICE]),
      [UUID_EXTERNAL_ID]: item[UUID_EXTERNAL_ID],
      [MAPPING_STATUS_COLUMN]: findMappingStatus({
        item,
        posMenu,
        itemType: CAMEL_TYPES.items,
      }),
      [DEFAULT_MODIFIERS]: formatDefaultModifiers(item),
      [AS_INSTRUCTION]: item[AS_INSTRUCTION],
      [IGNORE]: item[IGNORE],
      [SHOW_DEFAULT_MODIFIERS]: item[DEFAULT_MODIFIERS] || !!item[SHOW_DEFAULT_MODIFIERS],
      [CONFIDENCE]: formatConfidence(item),
    }));
  })();

  return (
    <>
      <PanelContent
        filteredName={filteredName}
        setFilteredName={setFilteredName}
        setFilteredStatuses={setFilteredStatuses}
        setFilteredCategories={setFilteredCategories}
        columns={columns}
        dataSource={formatData}
      />
      <MappingActionButtons>{renderMappingActionButtons}</MappingActionButtons>
    </>
  );
}
